module.exports = __webpack_public_path__ + "bin/93122e795b0b6f44864fa1660dc1eede.jpg";